import { Constants } from 'src/app/core/constants';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { FormService } from 'src/app/services/form';
import { DataService } from 'src/app/services/data.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UpdateProposalStatusDTO } from 'src/app/models/internal/updateproposalstatusdto';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import Helper from 'src/app/core/utility/helper';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'app-proposal-rejection-reason',
    templateUrl: './proposal-rejection-reason.component.html',
    styleUrls: ['./proposal-rejection-reason.component.scss']
})

/**
 * TMS-16561 Need to prompt user to add rejection reason for already approved proposal
 * We require PE to provide rejection comments when rejecting an approved proposal.
 */
export class ProposalRejectionReasonComponent extends BasePage implements OnInit {
    proposalRejectionReasonForm: FormGroup;
    proposalId: string;
    updateProposalStatusDTO: UpdateProposalStatusDTO;
    public formErrors = {
        RejectionComment: ''
    };

    constructor (
        private dialogRef: MatDialogRef<ProposalRejectionReasonComponent>,
        @Inject(MAT_DIALOG_DATA) private inputUpdateProposalStatusDTO: UpdateProposalStatusDTO,
        private fb: FormBuilder,
        private dataService: DataService,
        private FormService: FormService,
        private toastService: ToastService,
        localstorageService: LocalstorageService,
        logger: NGXLogger,
        appSettings: AppSettings
    ) { 
        super(localstorageService, logger, appSettings);   
        this.updateProposalStatusDTO = inputUpdateProposalStatusDTO;     
    }

    ngOnInit() {
        this.proposalRejectionReasonForm = this.fb.group({
            RejectionComment: null
        });
        this.setFlags();
    }

    submit() {
        this.rejectProposal();
        this.dialogRef.close();
    }

    ValidateForm() {
        Helper.resetFormErrors(this.formErrors);

        this.formErrors = this.FormService.validateForm(
            <FormGroup>this.proposalRejectionReasonForm,
            this.formErrors
        );
    }

    rejectProposal() {
        this.ValidateForm();
        if (this.proposalRejectionReasonForm.valid) {
            this.prepareModel(Constants.WORKFLOW_STATUS_REJECTED);
            this.updateProposalStatus();
        }
    }

    prepareModel(worflowStatusId: number) {
        this.updateProposalStatusDTO.WorkflowStatusId = worflowStatusId;
        this.updateProposalStatusDTO.RejectionComment = this.proposalRejectionReasonForm.controls['RejectionComment'].value;
    }

    updateProposalStatus() {
        this.scrollToTop();
        this.dataService
            .updateProposalsStatus(this.updateProposalStatusDTO)
            .subscribe(data => {
                if (data != null) {
                this.toastService.success(
                    'Proposal Status ' + Constants.SUCCESS_SAVE_GENERIC
                );
            }
        });
    }
}
